import * as ActionTypes from './types';

export function deleteCategory(payload) {
    return {
        type: ActionTypes.DELETE_CATEGORY,
        payload: payload
    }
}

export function deleteCategorySuccess(payload) {
  return {
    type: ActionTypes.DELETE_CATEGORY_SUCCESS,
    payload: payload
  }
}

export function deleteCategoryFailed(payload) {
  return {
    type: ActionTypes.DELETE_CATEGORY_FAILED,
    payload: payload
  }
}

export function changeCategoryStore(payload) {
    return {
        type: ActionTypes.CHANGE_CATEGORY_STORE,
        payload: payload
    }
}

export function updateCategory(payload) {
  return {
    type: ActionTypes.UPDATE_CATEGORY,
    payload: payload
  }
}

export function updateCategorySuccess(payload) {
  return {
    type: ActionTypes.UPDATE_CATEGORY_SUCCESS,
    payload: payload
  }
}

export function updateCategoryFailed(payload) {
  return {
    type: ActionTypes.UPDATE_CATEGORY_FAILED,
    payload: payload
  }
}

export function getCategoryById(payload) {
  return {
    type: ActionTypes.GET_CATEGORY_BY_ID,
    payload: payload
  }
}

export function getCategoryByIdSuccess(payload) {
  return {
    type: ActionTypes.GET_CATEGORY_BY_ID_SUCCESS,
    payload: payload
  }
}

export function getCategoryByIdFailed(payload) {
  return {
    type: ActionTypes.GET_CATEGORY_BY_ID_FAILED,
    payload: payload
  }
}

export function createCategory(payload) {
  return {
    type: ActionTypes.CREATE_CATEGORY,
    payload: payload
  }
}

export function createCategorySuccess(payload) {
  return {
    type: ActionTypes.CREATE_CATEGORY_SUCCESS,
    payload: payload
  }
}

export function createCategoryFailed(payload) {
  return {
    type: ActionTypes.CREATE_CATEGORY_FAILED,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/category.js